import { BEInterface } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEInterface';
import { EnumBEType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumBEType';

export class BEInterfaceExtend {
  public static Init(dto: BEInterface) {
    dto.bEType = EnumBEType.BEInterface;
  }
}
